/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Meta_UnlinkInputs */

const cs_settings_meta_unlink = /** @type {(inputs: Settings_Meta_UnlinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odpojit Meta`)
};

const en_settings_meta_unlink = /** @type {(inputs: Settings_Meta_UnlinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unlink Meta`)
};

/**
* | output |
* | --- |
* | "Unlink Meta" |
*
* @param {Settings_Meta_UnlinkInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_meta_unlink = /** @type {((inputs?: Settings_Meta_UnlinkInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Meta_UnlinkInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_meta_unlink(inputs)
	return cs_settings_meta_unlink(inputs)
});